import { createContext } from "react";
import type { User } from "@/types/User";

interface SessionContextType {
  user: User | null;
}

export const SessionContext = createContext<SessionContextType | null>(null);
